import { Input, Output, EventEmitter } from '@angular/core';
import { DataService } from '../../services/data.service';
import { StoreService } from '../../services/store.service';
import { ToolsService } from '../../services/tools.service';
import { pages, WaiverSteps } from '../../alv-enums';
import * as tools from '../../tools';
import { WaiverService } from 'src/app/services/waiver.service';
import { Utility } from 'src/app/common/utility';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { Router } from '@angular/router';

export class BaseCheckoutComponent {

	@Input() protected registerId: number;
	@Input() protected kioskId: number;
	@Output() protected pageChange = new EventEmitter<pages>();
	captcha : boolean = false;

	constructor(protected dataService: DataService
		, public storeService: StoreService
		, protected toolsService: ToolsService
		, protected waiverService: WaiverService
		, protected recaptchaV3Service: ReCaptchaV3Service
		, protected router: Router
	) { }  

	public orderNow() {
		const self = this;

		self.recaptchaV3Service.execute('postguestcheckout')
		.subscribe((token) => {
			self.checkoutOrder(token,3)
		});
	}

	public checkoutOrder(token, tokenVersion){
		const self = this;
		const postData = {
			registerId: self.registerId,
			orderId: self.storeService.shoppingCart.orderId,
			browserOffset: tools.geBrowserTimeZoneandOffset(),
			products: self.storeService.shoppingCart.products,
			token : token,
			tokenVersion : tokenVersion
		};
		self.dataService.post<any>(`/Checkout/CheckoutOrder`, postData)
			.then(response => {
				self.toolsService.ProcessHttpResponse(response, () => {
					if(response.data.captcha){
					this.storeService.antiForgeryToken = Utility.readAntiForgeryToken();
					self.storeService.shoppingCart.orderId = response.data.orderId;
					localStorage.setItem("orderId",response.data.orderId)
					self.storeService.shoppingCart.transactionId = response.data.transactionId;
					self.pageChange.emit(pages.CustomerInfo);
					if(self.storeService.kioskSettings.hideInfoStep){
						if(self.storeService.kioskSettings.waiverRequired){
							self.pageChange.emit(pages.Waiver);
							self.waiverService.onStepChangeForward(WaiverSteps.email)
							}
							else
							self.pageChange.emit(pages.Pay)
					}
					else{
						self.pageChange.emit(pages.CustomerInfo);
					}
				}
				else{
					self.captcha = true;
					if(response.data.attemptsExceeded >= 3){
                      this.gotToDashBoard();
					}
				}
				});
			});
	}

	gotToDashBoard() {
		if (this.registerId) {
			if (this.kioskId) {
				this.router.navigate([`/dashboard/${this.registerId}/${this.kioskId}`]);
			} else {
				this.router.navigate([`/dashboard/${this.registerId}`]);
			}
		}
    }
}
